import defaultTo from 'lodash/defaultTo';

import type { UpdateInvestorFirmEmployeeInput } from '../../../../../../../graphql';
import type { FirmInvestorContactsGridItemFragment } from '../FirmsInvestorContactsGrid/graphql/__generated__';

export type UpdateInvestorFirmEmployee = UpdateInvestorFirmEmployeeInput & {
  employeeKey: string | null;
};

export function getInitialValues(
  investorContact: FirmInvestorContactsGridItemFragment | null
): UpdateInvestorFirmEmployee | null {
  if (!investorContact) {
    return null;
  }
  return {
    employeeKey: defaultTo(investorContact.investorEmployeeKey, null),
    name: defaultTo(investorContact.name, ''),
    status: investorContact.status,
    titles: defaultTo(investorContact.titles, []),
    email1: defaultTo(investorContact.email1, ''),
    email2: defaultTo(investorContact.email2, ''),
    phoneNumber1: defaultTo(investorContact.phone1, ''),
    phoneNumber2: defaultTo(investorContact.phone2, ''),
    faxNumber1: defaultTo(investorContact.fax1, ''),
    faxNumber2: defaultTo(investorContact.fax2, ''),
    address1: defaultTo(investorContact.address1, ''),
    address2: defaultTo(investorContact.address2, ''),
  };
}
